module.exports = __webpack_public_path__ + "41ae53b3762497702146a94aa3761605.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-31.png
// module id = 2576
// module chunks = 0